import { types } from "../actions";

export default (state = null, { type, payload }) => {
  switch (type) {
    case types.SET_CUSTOMER:
      return payload;
    default:
      return state;
  }
};
